import { PhoneCallAvailabilitySelectorPrompt } from '@components/app/ApplyPackagePage/PhoneCallAvailabilitySelector'
import type { PhoneCallAvailability } from '@components/app/ApplyPackagePage/PhoneCallAvailabilitySelector/types'
import usePostTrialApplyStepViewedEvent from '@components/hooks/usePostTrialApplyStepViewedEvent'
import { Icon } from '@components/primitives/Icon'
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { useState } from 'react'

export function PhoneCallAvailabilitySelectorQuestion({
  idToken,
  mostQualifiedTrialApplicationIdToken,
  patientTimezone,
}: Pick<
  ApplySuccessPageProps,
  | 'idToken'
  | 'mostQualifiedTrialApplicationIdToken'
  | 'patientIdToken'
  | 'patientTimezone'
>) {
  const [selectedSlots, setSelectedSlots] = useState<PhoneCallAvailability[]>(
    [],
  )

  usePostTrialApplyStepViewedEvent({
    mostQualifiedTrialApplicationIdToken,
    trialApplicationIdToken: idToken,
    type: 'phone-call-availability',
  })

  return (
    <div className='flex h-full flex-col gap-4'>
      <div className='fixed inset-0 -z-10 bg-gradient-to-b from-white via-white to-primary50' />
      <div className='flex flex-col gap-4'>
        <Icon
          className='mx-auto size-8 rounded-full bg-primary50 p-6 text-primary500'
          icon={faCalendar}
        />
        <h1 className='text-2xl font-extrabold leading-[130%] text-black md:text-3xl'>
          Select a time you’re free for a call
        </h1>
      </div>
      <PhoneCallAvailabilitySelectorPrompt
        patientTimezone={patientTimezone}
        selectedSlots={selectedSlots}
        setSelectedSlots={setSelectedSlots}
      />
    </div>
  )
}
